"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ItemSelector(props) {
  var selected = props.selected,
      handleSelect = props.handleSelect,
      isAvailable = props.isAvailable,
      thumbSrc = props.thumbSrc,
      label = props.label,
      variation = props.variation;
  return _react2["default"].createElement("div", {
    className: (0, _classnames2["default"])('vtex-sku-selector__item relative di pointer flex items-center', thumbSrc && 'vtex-sku-selector__item-image'),
    onClick: handleSelect
  }, _react2["default"].createElement("div", {
    className: (0, _classnames2["default"])('absolute frame-around b--action-primary br3 bw1', selected && 'ba')
  }), _react2["default"].createElement("div", {
    className: (0, _classnames2["default"])('w-100 h-100 ba br2 b b--muted-4 z-1 c-muted-5 flex items-center overflow-hidden', selected || 'hover-b--muted-2')
  }, _react2["default"].createElement("div", {
    className: (0, _classnames2["default"])('absolute absolute--fill', isAvailable || 'diagonal-cross')
  }), _react2["default"].createElement("div", {
    className: (0, _classnames2["default"])(thumbSrc || 'c-on-base center pl5 pr5 z-1')
  }, thumbSrc ? _react2["default"].createElement("img", {
    src: thumbSrc,
    alt: label
  }) : label)));
}

ItemSelector.propTypes = {
  label: _propTypes2["default"].string,
  selected: _propTypes2["default"].bool,
  handleSelect: _propTypes2["default"].func,
  thumbSrc: _propTypes2["default"].string,
  isAvailable: _propTypes2["default"].bool,
  variation: _propTypes2["default"].string
};
exports["default"] = ItemSelector;